import React from 'react'
import styled from '@emotion/styled';
import { color_highlights_blue, color_text_link, color_variants_main_bg } from '../../../constants/colors';
import IconTooltip from '../../../components/general/IconTooltip';
import { css } from '@emotion/css';
import TooltipWrapper from '../../../components/general/TooltipWrapper';

const synonymsIcon = require('../../../content/images/synonyms.svg');

interface SynonymIndicatorProps {
    text?: string
    tooltip?: string
    compact?: boolean
}

const MenuSynonymIndicator: React.FC<SynonymIndicatorProps> = (props) => {
    const indicator = (
        <Indicator className={props.compact ? "compact" : ""} onClick={(e) => e.stopPropagation()}>
            <SynonymIcon className={props.compact ? "compact" : ""} src={synonymsIcon} alt="Synonyms" />
            {!props.compact && <span>{props.text ?? "Synonyms"}</span>}
            {props.tooltip && !props.compact &&
                <IconTooltip
                    text={props.tooltip}
                    place="right"
                    className={synonymTooltipStyle}
                />
            }
        </Indicator>
    );

    if (props.compact && props.tooltip) {
        return (
            <TooltipWrapper text={props.tooltip} place="right">
                {indicator}
            </TooltipWrapper>
        );
    }

    return indicator;
}

const Indicator = styled.div`
    display: flex;
    align-items: center;
    width: fit-content;
    margin-left: 8px;
    padding: 3px 8px;
    border: 1px solid ${color_highlights_blue};
    border-radius: 12px;
    background: ${color_variants_main_bg};
    color: ${color_text_link};
    font-size: 12px;
    font-weight: 600;

    &.compact {
        padding: 0;
        border: none;
        border-radius: 0;
        background: transparent;
    }
`;

const SynonymIcon = styled.img`
    width: 14px;
    height: 14px;
    margin-right: 5px;

    &.compact {
        margin-right: 0;
    }
`;

const synonymTooltipStyle = css`
    margin-left: 6px;
`;

export default MenuSynonymIndicator;
